import { FaChevronRight } from 'react-icons/fa';
import classnames from 'classnames';
import { OutgoingEventProductDto } from 'api/dtos/events/products';
import { OfferType, PromoterOfferContractTierDto } from 'legacy/events/types';
import { useFormikContext } from 'formik';

export type PromoterOfferTier =
  | OutgoingEventProductDto
  | PromoterOfferContractTierDto;
interface TierSelectionProps {
  tiers: PromoterOfferTier[];
  handleOnPress: () => void;
}

const TierSelection = ({ tiers, handleOnPress }: TierSelectionProps) => {
  const { values } = useFormikContext<OfferType>();
  const eligibleTiersCount = tiers?.length || 0;
  const hasActiveContract = values.contracts?.length > 0;
  const selectedTierText = tiers
    ?.slice(0, 2)
    .map((item) => `${item.name} ($${item.price})`)
    .join(', ');
  const remainingTierText =
    eligibleTiersCount - 2 > 0 ? `... +${eligibleTiersCount - 2} more` : '';
  const totalTierText =
    eligibleTiersCount > 0
      ? `${selectedTierText} ${remainingTierText}`
      : 'Any Tier';

  return (
    <div>
      <div className="relative">
        <div className="cursor-pointer" onClick={handleOnPress}>
          <input
            type="text"
            id="selectedTiers"
            name="selectedTiers"
            value={totalTierText}
            disabled={hasActiveContract}
            className={classnames(
              'w-full border-1 border-[#DCDCDC] px-2 py-2 mx-auto h-12 rounded-md mt-2 text-black'
            )}
            readOnly
          />
          <span
            className={classnames(
              'absolute right-3 top-1/2 transform -translate-y-1/4'
            )}
          >
            <FaChevronRight className="text-[#B1B1B1] h-4 w-4" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default TierSelection;
